import React, { useState } from "react";
import apiRoot from "../../../api/apiRoot";
import TypographyTable from "./TypographyTable";

const TypographyImport = ({
  setFonts,
  currentProjectId,
  setCurrentProjectId,
  setProjectIds,
  projectIds,
}) => {
  const [inputProjectId, setInputProjectId] = useState("");
  const [projectStyles, setProjectStyles] = useState("");

  async function handleOnSubmit(projectId) {
    setCurrentProjectId(projectId);

    if (projectIds.filter((item) => item === projectId).length === 0) {
      setProjectIds([...projectIds, projectId]);
    }

    const res = await apiRoot.post("/retrieveFonts", { projectId: projectId });

    setProjectStyles(res.data);
    setFonts(res.data);
  }

  function renderProjectIds() {
    if (projectIds.length > 0) {
      return projectIds.map((item) => {
        return (
          <div className="recent-project" key={item}>
            <div className="recent-project-id">{item}</div>
            <button className="header-link-item" onClick={() => handleOnSubmit(item)}>
              Load Project
            </button>
          </div>
        );
      });
    }
    return null;
  }

  return (
    <div className="typography-import-container">
      <div className="typography-text-input-container">
        <div className="typography-text-input">
          Adobe Font ID
          <input
            type="text"
            value={inputProjectId}
            onChange={(e) => setInputProjectId(e.target.value)}></input>
          <button className="header-link-item" onClick={() => handleOnSubmit(inputProjectId)}>
            Submit
          </button>
        </div>
        <div className="recent-projects">{renderProjectIds()}</div>
      </div>
      <TypographyTable currentProjectId={currentProjectId} styles={projectStyles} />
    </div>
  );
};

export default TypographyImport;
